var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"popper-class":("fraud_tooltip tooltip-" + _vm.size)}},[_c('i',{class:("el-icon-warning-outline " + _vm.filterColor)}),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(" "+_vm._s(_vm.tooltipContent)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }